// Function to decode HTML entities but keep HTML tags
export default function decodeOnlyHTMLEntities(text: string) {
    if (!text) return ''
    
    // Create a temporary element to decode HTML entities
    const temp = document.createElement('textarea')
    temp.innerHTML = text.replace(/&amp;nbsp;/g, ' ')
    return temp.value
}